import { useMemo } from "react";
import { resources } from "@constants/hardcoded-strings";
import { AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { mapEntitiesWithNameAndIdToSelectOptions } from "@utils/select-option-mapping-util";
import { sortStrings } from "@utils/string-util";
import { SelectFormGroup } from "../select-form-group/select-form-group";
import { BaseSelectFormGroupProps } from "./base-select-form-group-props";

type RelyingPartySelectFormGroupProps = BaseSelectFormGroupProps & {
    axnRelyingParties: Array<AxnRelyingParty>
};

export const RelyingPartySelectFormGroup = (props: RelyingPartySelectFormGroupProps) => {
    const { axnRelyingParties, onChange, selectedOption, idPrefix, disabled, isRequired, isSearchable, isClearable, labelWidth } = props;

    const relyingPartyOptions = useMemo(() => {
        return mapEntitiesWithNameAndIdToSelectOptions(axnRelyingParties).sort((a, b) => sortStrings(a.label, b.label));
    }, [axnRelyingParties]);

    return (
        <SelectFormGroup
            controlId={`${idPrefix}-relying-party-select`}
            label={resources.common.inputs.relyingParty.label}
            ariaLabel={resources.common.inputs.relyingParty.label}
            automationId={`${idPrefix}-relying-party-select`}
            onChange={onChange}
            options={relyingPartyOptions}
            selectedOption={selectedOption}
            disabled={disabled}
            isRequired={isRequired}
            isSearchable={isSearchable}
            isClearable={isClearable}
            labelWidth={labelWidth}
        />
    );
};